<template>
  <sb-anchor :href="link" :target="target">
    <slot />
  </sb-anchor>
</template>

<script>
export default {
  name: 'HelpCenterLink',
  components: {},
  mixins: [],
  props: {
    linkKey: {
      type: [String, Array],
      default: undefined
    },
    target: {
      type: String,
      default: '_blank',
      validator: value => {
        return value.match(/(_self|_blank)/)
      }
    }
  },
  data: () => ({}),
  mounted () {},
  destroyed () {},
  watch: {},
  computed: {
    link () {
      return this.$sbHelpCenter.link(this.linkKey)
    }
  },
  methods: {},
  directives: {},
  filters: {},
  i18n: { messages: {} }
}
</script>
